// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"d4e88e51","7880":"d4e88e51"}[chunkId] + ".chunk.css";
};